import {
  useCallback, useMemo,
} from 'react';
import { useDispatch } from 'react-redux';
import type { ModalProps } from '~/modal/modalType.enum';
import { DataLayerEditorModalContainer } from '~/sidebar/sidebarApps/mapTools/dataLayersTool/modals/dataLayerEditorModal.container';
import type { BoundaryGroupId } from '~/store/boundaries/boundaryIdentifier.type';
import type { DemographicRegion } from '~/store/demographics/demographics.types';
import {
  mapSettingsDataLayersAddDataLayer, mapSettingsDataLayersUpdateBoundaryGroup,
} from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.actionCreators';
import { createDataLayer } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.factory';
import type { DataLayerData } from '~/store/mapSettings/data/dataLayers/mapSettingsDataLayers.state';

export const DataLayerCreateModalContainer = ({
  boundaryGroupId,
  initialRegion,
  ...modalProps
}: ModalProps<{
  boundaryGroupId: BoundaryGroupId;
  initialRegion?: DemographicRegion;
}>) => {
  const dispatch = useDispatch();

  const handleSubmit = useCallback((dataLayerData: DataLayerData) => {
    const newLayer = createDataLayer({
      ...dataLayerData,
    });
    dispatch(mapSettingsDataLayersUpdateBoundaryGroup(newLayer.id, boundaryGroupId));
    dispatch(mapSettingsDataLayersAddDataLayer(newLayer));
    modalProps.onClose();
  }, [dispatch, boundaryGroupId, modalProps]);

  const initialData = useMemo(() => ({
    region: initialRegion,
  }), [initialRegion]);

  return (
    <DataLayerEditorModalContainer
      boundaryGroupId={boundaryGroupId}
      initialData={initialData}
      onSubmit={handleSubmit}
      {...modalProps}
    />
  );
};
